<template><div class="section-header" :class="{center}"><span v-if="eyebrow" class="eyebrow">{{eyebrow}}</span><h2>{{title}}</h2><p v-if="text">{{text}}</p><slot/></div></template>
<script>export default {name:'SectionHeader',props:{eyebrow:String,title:{type:String,required:true},text:String,center:Boolean}}</script>
